import { writable } from 'svelte/store';
const browser = typeof window !== 'undefined';

// Store for current database info
export const currentDatabase = writable(null);

// Fetch current database info from API
export async function fetchCurrentDatabase() {
  if (!browser) return;
  
  try {
    const res = await fetch('/api/v1/db/list');
    if (res.ok) {
      const data = await res.json();
      currentDatabase.set(data.current);
      return data.current;
    }
  } catch (e) {
    console.error('Failed to fetch current database:', e);
  }
  return null;
}

// Get the app title based on current database
// In single-db mode, the API returns VITE_APP_TITLE as the title
// In multi-db mode, uses the database's configured title
export function getAppTitle(db) {
  // If db has a title, use it (works for both single-db and multi-db mode)
  if (db?.title) {
    return db.title;
  }
  
  // For multi-db mode without title, show name in parentheses
  if (db?.name && db.name !== 'Default') {
    return `Summa Cloud (${db.name})`;
  }
  
  // Fallback to VITE_APP_TITLE or default
  if (browser) {
    return import.meta.env.VITE_APP_TITLE || 'Summa Cloud';
  }
  
  return 'Summa Cloud';
}
